// =============================================================================
// ACT MATH TEST BANK
// Form 25MC4 (Official ACT Prep Guide 2025-2026, Practice Test 4)
// =============================================================================
//
// SOURCE: The Official ACT Prep Guide (2025-2026 Edition)
// TYPE: Practice Test (Enhanced ACT Format)
// USE: TESTING MODE
//
// FORMAT: Enhanced ACT
//   - 45 total questions, 41 scored
//   - 4 field test questions (Q8, Q16, Q29, Q40 based on answer key shading)
//   - 50 minutes
//
// =============================================================================

export const FORM_METADATA = {
  formId: '25MC4',
  source: 'Official ACT Prep Guide 2025-2026',
  testType: 'Practice Test',
  format: 'Enhanced',
  totalQuestions: 45,
  scoredQuestions: 41,
  fieldTestPositions: [8, 16, 29, 40],
  timeMinutes: 50
};

// Official Scale Score Conversion (Practice Test 4)
export const SCALE_SCORE_TABLE_25MC4 = [
  { raw: 41, scale: 36 }, { raw: 40, scale: 36 },
  { raw: 39, scale: 35 }, { raw: 38, scale: 35 },
  { raw: 37, scale: 34 }, { raw: 36, scale: 34 },
  { raw: 35, scale: 33 },
  { raw: 34, scale: 32 },
  { raw: 33, scale: 31 },
  { raw: 32, scale: 30 },
  { raw: 31, scale: 29 },
  { raw: 30, scale: 28 }, { raw: 29, scale: 28 },
  { raw: 28, scale: 27 },
  { raw: 27, scale: 26 },
  { raw: 26, scale: 25 }, { raw: 25, scale: 25 },
  { raw: 24, scale: 24 },
  { raw: 23, scale: 23 },
  { raw: 22, scale: 22 },
  { raw: 21, scale: 21 },
  { raw: 20, scale: 20 },
  { raw: 19, scale: 19 },
  { raw: 18, scale: 18 }, { raw: 17, scale: 18 },
  { raw: 16, scale: 17 }, { raw: 15, scale: 17 },
  { raw: 14, scale: 16 }, { raw: 13, scale: 16 },
  { raw: 12, scale: 15 }, { raw: 11, scale: 15 },
  { raw: 10, scale: 14 }, { raw: 9, scale: 14 }, { raw: 8, scale: 14 }, { raw: 7, scale: 14 },
  { raw: 6, scale: 13 },
  { raw: 5, scale: 12 },
  { raw: 4, scale: 11 },
  { raw: 3, scale: 9 },
  { raw: 2, scale: 7 },
  { raw: 1, scale: 5 },
  { raw: 0, scale: 1 }
];

// =============================================================================
// COMPLETE TEST BANK - FORM 25MC4 (45 Questions)
// =============================================================================

export const questions_25MC4 = [
  // -------------------------------------------------------------------------
  // QUESTION 1 - Parallelogram consecutive angles
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q01',
    formId: '25MC4',
    questionNumber: 1,
    categories: ['G'],
    difficulty: 1,
    topics: ['parallelograms', 'angles'],
    question: 'The parallelogram shown has consecutive angles with measures x° and 25°. What is the value of x?',
    choices: ['100', '115', '130', '155'],
    correctIndex: 3,
    correctLetter: 'D',
    explanation: 'Consecutive angles in a parallelogram are supplementary. x + 25 = 180, so x = 155.',
    hasFigure: true,
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 2 - Average daily commission
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q02',
    formId: '25MC4',
    questionNumber: 2,
    categories: ['S'],
    difficulty: 1,
    topics: ['mean', 'average'],
    question: "A retail sales associate's daily commission during 1 week was $30 on Monday and Tuesday and $70 on Wednesday, Thursday, and Friday. What was the associate's average daily commission for these 5 days?",
    choices: ['$50', '$51', '$54', '$55'],
    correctIndex: 2,
    correctLetter: 'H',
    explanation: 'Average = (30 + 30 + 70 + 70 + 70)/5 = 270/5 = $54.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 3 - Greatest common factor
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q03',
    formId: '25MC4',
    questionNumber: 3,
    categories: ['N'],
    difficulty: 1,
    topics: ['gcd-lcm', 'number-properties'],
    question: 'What is the greatest common factor of 45, 50, and 84?',
    choices: ['0', '1', '2', '3'],
    correctIndex: 1,
    correctLetter: 'B',
    explanation: '45 = 3²×5, 50 = 2×5², 84 = 2²×3×7. No common prime factors, so GCF = 1.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 4 - Linear equation
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q04',
    formId: '25MC4',
    questionNumber: 4,
    categories: ['A'],
    difficulty: 1,
    topics: ['linear-equations'],
    question: 'For what value of x is the equation 2(x − 12) + x = 36 true?',
    choices: ['4', '8', '16', '20'],
    correctIndex: 3,
    correctLetter: 'J',
    explanation: '2(x − 12) + x = 36. 2x − 24 + x = 36. 3x = 60. x = 20.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 5 - Probability (not white button)
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q05',
    formId: '25MC4',
    questionNumber: 5,
    categories: ['S'],
    difficulty: 1,
    topics: ['probability-basic'],
    question: 'A bag contains exactly 22 solid-colored buttons: 4 red, 6 blue, and 12 white. What is the probability of randomly selecting 1 button that is not white?',
    choices: ['5/11', '5/6', '1/22', '1/10'],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: 'Not white = red + blue = 4 + 6 = 10. P(not white) = 10/22 = 5/11.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 6 - Map scale
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q06',
    formId: '25MC4',
    questionNumber: 6,
    categories: ['N'],
    difficulty: 1,
    topics: ['proportions', 'ratios', 'unit-conversion'],
    question: 'On a map, ½ inch represents 12 miles. Two towns that are 5 inches apart on this map are how many miles apart?',
    choices: ['120', '60', '30', '24'],
    correctIndex: 0,
    correctLetter: 'F',
    explanation: '½ inch = 12 miles, so 1 inch = 24 miles. 5 inches = 5 × 24 = 120 miles.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 7 - Linear model (movie service)
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q07',
    formId: '25MC4',
    questionNumber: 7,
    categories: ['A'],
    difficulty: 1,
    topics: ['linear-equations', 'modeling'],
    question: 'An on-demand movie service charges $5 per month, plus $2 for each movie rented. Which of the following equations models the relationship between M, the number of movies rented per month, and T, the total monthly charge, in dollars, for the service?',
    choices: ['M = 5 + 2T', 'M = 2 + 5T', 'T = 5 + 2M', 'T = 2 + 5M'],
    correctIndex: 2,
    correctLetter: 'C',
    explanation: 'Monthly charge = base fee + per-movie charge = $5 + $2M. So T = 5 + 2M.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 8 - Quadratic equation solutions (FIELD TEST)
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q08',
    formId: '25MC4',
    questionNumber: 8,
    categories: ['A'],
    difficulty: 2,
    topics: ['quadratic-equations', 'factoring'],
    question: 'What are the solutions to the quadratic equation (2x + 5)(3x − 4) = 0?',
    choices: ['−5 and 4', '−5/2 and −4/3', '−5/2 and 4/3', '5/2 and −4/3'],
    correctIndex: 2,
    correctLetter: 'H',
    explanation: '2x + 5 = 0 gives x = −5/2. 3x − 4 = 0 gives x = 4/3. Solutions: −5/2 and 4/3.',
    isScored: false  // Field test question
  },

  // -------------------------------------------------------------------------
  // QUESTION 9 - Fraction not participating
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q09',
    formId: '25MC4',
    questionNumber: 9,
    categories: ['N'],
    difficulty: 2,
    topics: ['fractions'],
    question: 'In a class of tenth graders, no student participated in more than 1 of the following extracurricular activities: 2/3 of the class played in the band; 1/6 sang in the chorus; 1/10 played football; and 1/60 played basketball. What fraction of the class did not participate in any 1 of these 4 activities?',
    choices: ['0', '1/20', '74/79', '57/60'],
    correctIndex: 1,
    correctLetter: 'B',
    explanation: 'Sum = 2/3 + 1/6 + 1/10 + 1/60 = 40/60 + 10/60 + 6/60 + 1/60 = 57/60. Not participating = 1 − 57/60 = 3/60 = 1/20.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 10 - Triangle with sine
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q10',
    formId: '25MC4',
    questionNumber: 10,
    categories: ['G'],
    difficulty: 2,
    topics: ['trig-ratios', 'triangles'],
    question: 'In △ABC shown, sin C = 2/3, and the length of AB is 6 inches. What is the length, in inches, of AC?',
    choices: ['√5', '√13', '4', '9'],
    correctIndex: 3,
    correctLetter: 'J',
    explanation: 'sin C = opposite/hypotenuse = AB/AC = 6/AC = 2/3. AC = 6 × 3/2 = 9.',
    hasFigure: true,
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 11 - Arithmetic sequence
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q11',
    formId: '25MC4',
    questionNumber: 11,
    categories: ['F'],
    difficulty: 2,
    topics: ['arithmetic-sequences'],
    question: 'The table shows the first 5 terms of an arithmetic sequence. Which of the following is a general expression for the nth term?',
    choices: ['2n − 1', '3n − 2', '4n − 3', '5n − 4'],
    correctIndex: 2,
    correctLetter: 'C',
    explanation: 'Sequence: 1, 5, 9, 13, 17. Common difference = 4. nth term = 1 + (n−1)×4 = 4n − 3.',
    hasFigure: true,
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 12 - Free throw percentage
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q12',
    formId: '25MC4',
    questionNumber: 12,
    categories: ['IES'],
    difficulty: 2,
    topics: ['word-problems', 'percents'],
    question: 'So far this basketball season, Sherita has made 46 of her first 60 free throws, which gives her a free throw average of about 76.7%. What is the minimum number of free throws she would need to make from now on in order to have a free throw average of at least 80%?',
    choices: ['2', '3', '10', '14'],
    correctIndex: 2,
    correctLetter: 'H',
    explanation: 'Need (46 + x)/(60 + x) ≥ 0.80. Solving: 46 + x ≥ 48 + 0.8x. 0.2x ≥ 2. x ≥ 10.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 13 - Composite functions
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q13',
    formId: '25MC4',
    questionNumber: 13,
    categories: ['F'],
    difficulty: 2,
    topics: ['composite-functions'],
    question: 'Two functions are defined as f(x) = 2x − 1 and g(x) = x² + 1. Which of the following expressions represents f(g(x))?',
    choices: ['x² + 2x', '2x² + 1', '2x² + 2', '4x² − 4x + 2'],
    correctIndex: 1,
    correctLetter: 'B',
    explanation: 'f(g(x)) = f(x² + 1) = 2(x² + 1) − 1 = 2x² + 2 − 1 = 2x² + 1.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 14 - Mean and median comparison
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q14',
    formId: '25MC4',
    questionNumber: 14,
    categories: ['S'],
    difficulty: 2,
    topics: ['mean', 'median'],
    question: 'Dataset A consists of the 8 numbers listed. Dataset B consists of the 8 numbers in A and a 9th number that is greater than 90. How will the mean and the median of B compare to the mean and the median of A?\n\n62, 76, 76, 80, 82, 87, 94, 96',
    choices: [
      'The mean and the median of B will each be greater than the mean and the median of A, respectively.',
      'The mean and the median of B will each be less than the mean and the median of A, respectively.',
      'The mean of B will be the same as the mean of A, and the median of B will be greater than the median of A.',
      'The mean of B will be greater than the mean of A, and the median of B will be the same as the median of A.'
    ],
    correctIndex: 0,
    correctLetter: 'F',
    explanation: 'Mean of A = 81.625, Median of A = 81. Adding a number > 90 increases the mean and shifts the median to 82 (the 5th value of 9).',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 15 - Radiator leak rate
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q15',
    formId: '25MC4',
    questionNumber: 15,
    categories: ['IES'],
    difficulty: 2,
    topics: ['rate-problems', 'word-problems'],
    question: 'A truck traveling at 35 mph has a leaky radiator that is losing 4 fluid ounces per minute. If the radiator held 480 fluid ounces when it began to leak, how many miles will the truck travel before the radiator is empty?',
    choices: ['17.5', '35.0', '70.0', '120.0'],
    correctIndex: 2,
    correctLetter: 'C',
    explanation: 'Time to empty: 480/4 = 120 minutes = 2 hours. Distance = 35 × 2 = 70 miles.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 16 - Midpoint (FIELD TEST)
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q16',
    formId: '25MC4',
    questionNumber: 16,
    categories: ['G'],
    difficulty: 1,
    topics: ['midpoint', 'coordinate-geometry'],
    question: 'In the standard (x,y) coordinate plane, what is the midpoint of the line segment that has endpoints (−5,8) and (3,−1)?',
    choices: ['(−2,−9)', '(−1, 7/2)', '(4, −9/2)', '(8,−9)'],
    correctIndex: 1,
    correctLetter: 'G',
    explanation: 'Midpoint = ((−5+3)/2, (8+(−1))/2) = (−2/2, 7/2) = (−1, 7/2).',
    isScored: false  // Field test question
  },

  // -------------------------------------------------------------------------
  // QUESTION 17 - Linear function from table
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q17',
    formId: '25MC4',
    questionNumber: 17,
    categories: ['F'],
    difficulty: 2,
    topics: ['linear-equations', 'function-evaluation'],
    question: 'The ordered pairs (x,y) in one of the following tables belong to a linear function. Which one?',
    choices: [
      'x: 0,1,2,3  y: 2,1,1,0',
      'x: 0,1,2,3  y: 3,2,1,0',
      'x: 0,1,2,3  y: 0,1,0,1',
      'x: 0,1,2,3  y: 0,1,4,9'
    ],
    correctIndex: 1,
    correctLetter: 'B',
    explanation: 'Table B has constant slope: (2−3)/(1−0) = (1−2)/(2−1) = (0−1)/(3−2) = −1. Linear function: y = −x + 3.',
    hasFigure: true,
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 18 - Triangle side ordering
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q18',
    formId: '25MC4',
    questionNumber: 18,
    categories: ['G'],
    difficulty: 2,
    topics: ['triangles', 'angles'],
    question: 'In △ABC shown, m∠A = x°, m∠B = (2x)°, m∠C = (3x)°, AB = c inches, AC = b inches, and BC = a inches. Which of the following inequalities correctly relates the side lengths of △ABC?',
    choices: ['a < b < c', 'a < c < b', 'b < a < c', 'c < b < a'],
    correctIndex: 0,
    correctLetter: 'F',
    explanation: 'x + 2x + 3x = 180°, so x = 30°. Angles: A = 30°, B = 60°, C = 90°. Larger angle opposite longer side: a < b < c.',
    hasFigure: true,
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 19 - Slope of line
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q19',
    formId: '25MC4',
    questionNumber: 19,
    categories: ['G'],
    difficulty: 1,
    topics: ['slope', 'coordinate-geometry'],
    question: 'What is the slope of the line that passes through (1,5) and (17,7) in the standard (x,y) coordinate plane?',
    choices: ['1/8', '2/3', '3/2', '8'],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: 'Slope = (7 − 5)/(17 − 1) = 2/16 = 1/8.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 20 - Rectangle perimeter
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q20',
    formId: '25MC4',
    questionNumber: 20,
    categories: ['G'],
    difficulty: 1,
    topics: ['rectangles', 'perimeter'],
    question: 'The perimeter of a particular rectangle is 36 centimeters. The longer sides of the rectangle are each 2 centimeters longer than each of the shorter sides of the rectangle. What is the length, in centimeters, of one of the longer sides of the rectangle?',
    choices: ['8', '9', '10', '18'],
    correctIndex: 2,
    correctLetter: 'H',
    explanation: 'Let shorter side = x. Then 2x + 2(x + 2) = 36. 4x + 4 = 36. x = 8. Longer side = 10.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 21 - Square and rectangle equal area
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q21',
    formId: '25MC4',
    questionNumber: 21,
    categories: ['G'],
    difficulty: 2,
    topics: ['area', 'rectangles'],
    question: 'One side of square ABCD has a length of 18 meters. A rectangle whose area is equal to the area of ABCD has a width of 6 meters. What is the length, in meters, of that rectangle?',
    choices: ['18', '24', '27', '54'],
    correctIndex: 3,
    correctLetter: 'D',
    explanation: 'Area of square = 18² = 324 m². Rectangle: 6 × length = 324. Length = 54 m.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 22 - Matrix operations
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q22',
    formId: '25MC4',
    questionNumber: 22,
    categories: ['N'],
    difficulty: 2,
    topics: ['matrices'],
    question: 'The 2 × 2 matrices A and B are related to matrix C by the equation C = 2A − 3B. What is matrix C?\n\nA = [3  5; −2  1]  B = [−4  5; 2  1]',
    choices: [
      '[18  −5; −10  −1]',
      '[10  5; −6  1]',
      '[6  −1; −5  −1]',
      '[−6  25; 2  5]'
    ],
    correctIndex: 0,
    correctLetter: 'F',
    explanation: '2A = [6 10; −4 2]. 3B = [−12 15; 6 3]. C = 2A − 3B = [6−(−12) 10−15; −4−6 2−3] = [18 −5; −10 −1].',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 23 - Area codes counting
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q23',
    formId: '25MC4',
    questionNumber: 23,
    categories: ['S'],
    difficulty: 2,
    topics: ['counting'],
    question: 'In the United States, phone numbers begin with a 3-digit area code. Now, there are restrictions on some of the digits, but in the future, as more and more area codes are needed, the restrictions may need to be lifted. If, and when, there are no restrictions and each of the 3 digits can be any integer from 0 through 9, how many area codes will be possible?',
    choices: ['30', '720', '729', '1,000'],
    correctIndex: 3,
    correctLetter: 'D',
    explanation: 'Each of 3 digits has 10 choices. Total = 10 × 10 × 10 = 1,000.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 24 - Sine function x-intercepts
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q24',
    formId: '25MC4',
    questionNumber: 24,
    categories: ['F'],
    difficulty: 3,
    topics: ['trig-functions'],
    question: 'The function y = 2sin(8πx) is graphed in the standard (x,y) coordinate plane. How many x-intercepts does the graph of this function have on the interval 0 < x < 1?',
    choices: ['4', '7', '8', '9'],
    correctIndex: 1,
    correctLetter: 'G',
    explanation: 'x-intercepts occur when sin(8πx) = 0, i.e., 8πx = nπ, x = n/8. On (0,1): x = 1/8, 2/8, 3/8, 4/8, 5/8, 6/8, 7/8. That\'s 7 intercepts.',
    hasFigure: true,
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 25 - Sum of fractions is integer
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q25',
    formId: '25MC4',
    questionNumber: 25,
    categories: ['N'],
    difficulty: 2,
    topics: ['fractions', 'number-properties'],
    question: 'If both x and (x/3 + x/7 + x/9) are positive integers, what is the least possible value of x?',
    choices: ['21', '27', '36', '63'],
    correctIndex: 3,
    correctLetter: 'D',
    explanation: 'x/3 + x/7 + x/9 = (21x + 9x + 7x)/63 = 37x/63. For this to be an integer, x must be a multiple of 63. Least = 63.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 26 - Radical expression multiplication
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q26',
    formId: '25MC4',
    questionNumber: 26,
    categories: ['A'],
    difficulty: 2,
    topics: ['radicals', 'polynomial-simplification'],
    question: 'Which of the following expressions is equal to (a + √b)(a − 2√b) for all positive real numbers a and b?',
    choices: ['a² − 3a√b', 'a² − a√b − 2b', 'a² − a√b − 2√2b', 'a² − 3a√b − 2b'],
    correctIndex: 1,
    correctLetter: 'G',
    explanation: '(a + √b)(a − 2√b) = a² − 2a√b + a√b − 2b = a² − a√b − 2b.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 27 - Figure-8 track circumference
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q27',
    formId: '25MC4',
    questionNumber: 27,
    categories: ['G'],
    difficulty: 2,
    topics: ['circles', 'rate-problems'],
    question: 'The track for a model railroad display is set up as 2 circles that are tangent to one another and have diameters of 30 feet and 50 feet, as shown. The engine of the train travels at a constant rate of 75 feet per minute. To the nearest minute, how many minutes does the engine take to go in a figure-8 pattern around the entire track exactly 1 time?',
    choices: ['1', '2', '3', '4'],
    correctIndex: 2,
    correctLetter: 'C',
    explanation: 'Total circumference = π(30) + π(50) = 80π ≈ 251.3 ft. Time = 251.3/75 ≈ 3.35 ≈ 3 minutes.',
    hasFigure: true,
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 28 - Negative fractional exponent
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q28',
    formId: '25MC4',
    questionNumber: 28,
    categories: ['N'],
    difficulty: 3,
    topics: ['exponents', 'radicals'],
    question: '(4/5)^(−3/2) = ?',
    choices: ['5/2', '5√5/8', '4√2/5', '√5/2'],
    correctIndex: 1,
    correctLetter: 'G',
    explanation: '(4/5)^(−3/2) = (5/4)^(3/2) = (√(5/4))³ = (√5/2)³ = 5√5/8.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 29 - Logarithm equation (FIELD TEST)
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q29',
    formId: '25MC4',
    questionNumber: 29,
    categories: ['F'],
    difficulty: 2,
    topics: ['logarithms'],
    question: 'What is the value of the positive real number x such that log_x(1/25) = −2?',
    choices: ['5', '50', '1/50', '1/5'],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: 'log_x(1/25) = −2 means x^(−2) = 1/25. So 1/x² = 1/25, x² = 25, x = 5.',
    isScored: false  // Field test question
  },

  // -------------------------------------------------------------------------
  // QUESTION 30 - Point on a line
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q30',
    formId: '25MC4',
    questionNumber: 30,
    categories: ['G'],
    difficulty: 2,
    topics: ['coordinate-geometry', 'slope'],
    question: 'The points (−4,−5), (0,−3), and (6,0) lie on a line in the standard (x,y) coordinate plane. Which of the following points also lies on that line?',
    choices: ['(−3,−4)', '(−1,−4)', '(1,−2)', '(4,−1)'],
    correctIndex: 3,
    correctLetter: 'J',
    explanation: 'Slope = (−3−(−5))/(0−(−4)) = 2/4 = 1/2. Line: y = (1/2)x − 3. Check (4,−1): −1 = 2 − 3 = −1. ✓',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 31 - Quadratic profit maximization
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q31',
    formId: '25MC4',
    questionNumber: 31,
    categories: ['F'],
    difficulty: 2,
    topics: ['quadratic-functions'],
    question: 'The CFO of Math King Enterprises estimates that if the company sells its new product for x cents per unit, the weekly profit will be modeled by p(x) = 1,600x − 4x², where 0 ≤ x ≤ 400. According to this model, for which of the following values of x will the weekly profit for this product be the greatest?',
    choices: ['40', '100', '200', '400'],
    correctIndex: 2,
    correctLetter: 'C',
    explanation: 'p(x) = −4x² + 1600x is maximized at x = −b/(2a) = −1600/(2×(−4)) = 200.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 32 - Consecutive integer fractions
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q32',
    formId: '25MC4',
    questionNumber: 32,
    categories: ['N'],
    difficulty: 2,
    topics: ['fractions', 'number-properties'],
    question: 'Given consecutive positive integers a, b, c, and d such that a < b < c < d, which of the following expressions has the greatest value?',
    choices: ['b/c', 'c/d', '(a+b)/(b+c)', '(b+c)/(c+d)'],
    correctIndex: 1,
    correctLetter: 'G',
    explanation: 'Using a=1, b=2, c=3, d=4: b/c=2/3≈0.667, c/d=3/4=0.75, (a+b)/(b+c)=3/5=0.6, (b+c)/(c+d)=5/7≈0.714. Greatest is c/d.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 33 - Similar squares ratio
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q33',
    formId: '25MC4',
    questionNumber: 33,
    categories: ['G'],
    difficulty: 2,
    topics: ['similar-triangles', 'ratios'],
    question: 'The ratio of the perimeters of two squares is 2:3. If the area of the larger square is 324 square feet, what is the length, in feet, of the side of the smaller square?',
    choices: ['12', '18', '24', '36'],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: 'Ratio of sides = 2:3. Ratio of areas = 4:9. Smaller area = 324 × (4/9) = 144 sq ft. Side = √144 = 12 ft.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 34 - Inequality with radical
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q34',
    formId: '25MC4',
    questionNumber: 34,
    categories: ['A'],
    difficulty: 2,
    topics: ['inequalities', 'radicals'],
    question: 'What is the set of all integer solutions for the inequality −1 ≤ x − √5 < 4?',
    choices: ['{3, 4, 5}', '{2, 3, 4, 5, 6}', '{2, 3, 4, 5}', '{1, 2, 3, 4, 5, 6}'],
    correctIndex: 1,
    correctLetter: 'G',
    explanation: 'Add √5: √5 − 1 ≤ x < √5 + 4. Since √5 ≈ 2.236: 1.236 ≤ x < 6.236. Integer solutions: {2, 3, 4, 5, 6}.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 35 - Wind force variation
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q35',
    formId: '25MC4',
    questionNumber: 35,
    categories: ['A'],
    difficulty: 3,
    topics: ['word-problems', 'proportions'],
    question: 'Wind blowing against a flat surface exerts a maximum force equal to kSv², where S is the area of the surface, v is the wind\'s velocity, and k is a constant. If a 40-mile-per-hour (mph) wind can exert a maximum force of 50 pounds on a 1-square-foot flat surface, what is the maximum force, in pounds, that an 80 mph wind can exert on a 2-square-foot flat surface?',
    choices: ['100', '200', '400', '1,600'],
    correctIndex: 2,
    correctLetter: 'C',
    explanation: '50 = k(1)(40²) = 1600k, so k = 1/32. F = (1/32)(2)(80²) = (1/32)(2)(6400) = 400 pounds.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 36 - Concrete sidewalk volume
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q36',
    formId: '25MC4',
    questionNumber: 36,
    categories: ['IES'],
    difficulty: 2,
    topics: ['volume', 'word-problems'],
    question: 'Roger is pouring concrete to make a sidewalk with the dimensions, in feet, shown in the figure. He pours the concrete to a depth of 4 inches. One bag of concrete mix makes 0.6 cubic feet of concrete. What is the least whole number of bags of concrete mix that Roger needs in order to make the sidewalk?',
    choices: ['44', '50', '58', '67'],
    correctIndex: 2,
    correctLetter: 'H',
    explanation: 'L-shape area: 4×10 + 20×4 − 4×4 = 40 + 80 − 16 = 104 sq ft. Volume = 104 × (4/12) = 104/3 ≈ 34.67 cu ft. Bags = 34.67/0.6 = 57.8 → 58 bags.',
    hasFigure: true,
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 37 - Circle tangent and secant
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q37',
    formId: '25MC4',
    questionNumber: 37,
    categories: ['G'],
    difficulty: 3,
    topics: ['circles', 'trig-ratios'],
    question: 'Radius OA of the circle shown is perpendicular to AP. The circle intersects OP at B. The length of AP is 12 centimeters, and the measure of ∠APO is 20°. Which of the following values is closest to the length, in centimeters, of BP?\n\n(Note: sin 20° ≈ 0.342, cos 20° ≈ 0.940, and tan 20° ≈ 0.364)',
    choices: ['4.4', '6.9', '7.6', '8.4'],
    correctIndex: 3,
    correctLetter: 'D',
    explanation: 'In right △OAP: OA = 12 tan 20° ≈ 4.37 (radius). OP = 12/cos 20° ≈ 12.77. BP = OP − OB = 12.77 − 4.37 ≈ 8.4.',
    hasFigure: true,
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 38 - Average after removing extremes
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q38',
    formId: '25MC4',
    questionNumber: 38,
    categories: ['S'],
    difficulty: 3,
    topics: ['mean'],
    question: 'The average of 10 test scores is x. When the highest score and lowest score are removed from the 10 scores, the average is y. Which of the following is an expression for the average of the highest score and lowest score?',
    choices: ['10x − 8y', '(x + y)/2', '(10x + 8y)/2', '(10x − 8y)/2'],
    correctIndex: 3,
    correctLetter: 'J',
    explanation: 'Sum of 10 = 10x. Sum of 8 middle = 8y. Sum of highest + lowest = 10x − 8y. Average = (10x − 8y)/2.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 39 - Exponential equation
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q39',
    formId: '25MC4',
    questionNumber: 39,
    categories: ['A'],
    difficulty: 3,
    topics: ['exponents', 'quadratic-equations'],
    question: 'Which of the following is the solution set of 27^(n²) = 9^(5n−4)?',
    choices: ['{−4, 2/3}', '{−1, 8/3}', '{−2/3, 4}', '{4/3, 2}'],
    correctIndex: 3,
    correctLetter: 'D',
    explanation: '3^(3n²) = 3^(2(5n−4)). 3n² = 10n − 8. 3n² − 10n + 8 = 0. (3n − 4)(n − 2) = 0. n = 4/3 or n = 2.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 40 - Two dice probability (FIELD TEST)
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q40',
    formId: '25MC4',
    questionNumber: 40,
    categories: ['S'],
    difficulty: 2,
    topics: ['probability-basic'],
    question: 'Each face of 2 cubes with faces numbered from 1 through 6 has a 1/6 chance of landing faceup when the 2 cubes are tossed. What is the probability that the sum of the numbers on the faces landing faceup will be less than 6?',
    choices: ['13/36', '5/12', '5/18', '5/36'],
    correctIndex: 2,
    correctLetter: 'H',
    explanation: 'Sum < 6: (1,1), (1,2), (2,1), (1,3), (2,2), (3,1), (1,4), (2,3), (3,2), (4,1) = 10 outcomes. P = 10/36 = 5/18.',
    isScored: false  // Field test question
  },

  // -------------------------------------------------------------------------
  // QUESTION 41 - Two cars meeting
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q41',
    formId: '25MC4',
    questionNumber: 41,
    categories: ['IES'],
    difficulty: 2,
    topics: ['rate-problems', 'word-problems'],
    question: 'At 2:00 p.m., Louisa leaves Kansas City in her car traveling east on I-70 toward St. Louis at an average speed of 68 mph. At precisely the same time, Antonio leaves St. Louis in his car traveling west on I-70 toward Kansas City at an average speed of 57 mph. The driving distance from St. Louis to Kansas City is 240 miles. At what time, to the nearest minute, will Louisa and Antonio drive past each other on I-70?',
    choices: ['3:46 p.m.', '3:53 p.m.', '3:55 p.m.', '4:06 p.m.'],
    correctIndex: 2,
    correctLetter: 'C',
    explanation: 'Combined speed = 68 + 57 = 125 mph. Time = 240/125 = 1.92 hours ≈ 1 hr 55 min. 2:00 + 1:55 = 3:55 p.m.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 42 - Distinct lines from points
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q42',
    formId: '25MC4',
    questionNumber: 42,
    categories: ['S'],
    difficulty: 2,
    topics: ['counting', 'permutations'],
    question: 'There are 10 points in a plane, and no 3 of the points are collinear. These 10 points, taken 2 points at a time, determine how many distinct lines?',
    choices: ['10', '20', '45', '90'],
    correctIndex: 2,
    correctLetter: 'H',
    explanation: 'C(10,2) = 10×9/2 = 45 distinct lines.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 43 - Factorial simplification
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q43',
    formId: '25MC4',
    questionNumber: 43,
    categories: ['N'],
    difficulty: 3,
    topics: ['factorials', 'counting'],
    question: 'The expression n! (read as "n factorial") is defined as the product of all positive integers up to and including n whenever n is a positive integer. For example, 4! = 1·2·3·4. Whenever n is a positive integer, which of the following is equivalent to (n+1)!6!/(n!3!)?',
    choices: ['120(n + 1)', '120', '2(n + 1)/n', '(6n + 6)!/(3n)!'],
    correctIndex: 0,
    correctLetter: 'A',
    explanation: '(n+1)!6!/(n!3!) = (n+1)·n!·720/(n!·6) = (n+1)·720/6 = 120(n+1).',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 44 - Binomial expansion coefficient
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q44',
    formId: '25MC4',
    questionNumber: 44,
    categories: ['A'],
    difficulty: 3,
    topics: ['binomial-theorem'],
    question: 'When (x + 1)⁴ is expanded and like terms are combined, what is the coefficient of x²?',
    choices: ['0', '1', '4', '6'],
    correctIndex: 3,
    correctLetter: 'J',
    explanation: 'Using binomial theorem: C(4,2)·x²·1² = 6x². Coefficient is 6.',
    isScored: true
  },

  // -------------------------------------------------------------------------
  // QUESTION 45 - Guy wire with law of cosines
  // -------------------------------------------------------------------------
  {
    id: '25MC4-Q45',
    formId: '25MC4',
    questionNumber: 45,
    categories: ['G'],
    difficulty: 3,
    topics: ['law-of-cosines', 'trig-ratios'],
    question: 'A hill makes an angle of 20° with the horizontal, AD, as shown in the figure. A taut guy wire, AB, extends from the base of the hill, point A, to point B on a vertical pole. Point B is 25 ft directly above where the pole is inserted into the ground at point C. Given that the length of AC is 60 ft, which of the following expressions represents the length, in feet, of the guy wire?',
    choices: [
      '25 sin 60°/sin 20°',
      '25 sin 70°/sin 20°',
      '√(60² + 25² − 2(60)(25) cos 70°)',
      '√(60² + 25² − 2(60)(25) cos 110°)'
    ],
    correctIndex: 3,
    correctLetter: 'D',
    explanation: 'The angle ACB = 180° − 70° = 110° (pole is vertical, hill rises at 20°). Using law of cosines: AB² = 60² + 25² − 2(60)(25)cos 110°.',
    hasFigure: true,
    isScored: true
  }
];

// =============================================================================
// CATEGORY SUMMARY
// =============================================================================

export const CATEGORY_COUNTS_25MC4 = {
  'A': 8,   // Algebra
  'F': 6,   // Functions
  'G': 12,  // Geometry
  'N': 7,   // Number & Quantity
  'S': 7,   // Statistics & Probability
  'IES': 5  // Integrating Essential Skills
};

// =============================================================================
// UTILITY FUNCTIONS
// =============================================================================

export function getScaleScore(rawScore) {
  const entry = SCALE_SCORE_TABLE_25MC4.find(e => e.raw === rawScore);
  if (entry) return entry.scale;
  const rangeEntry = SCALE_SCORE_TABLE_25MC4.find(e => e.raw >= rawScore);
  return rangeEntry ? rangeEntry.scale : 1;
}

export function getQuestionsByCategory(categoryCode) {
  return questions_25MC4.filter(q => q.categories.includes(categoryCode));
}

export function getScoredQuestions() {
  return questions_25MC4.filter(q => q.isScored);
}

export function getFieldTestQuestions() {
  return questions_25MC4.filter(q => !q.isScored);
}

export default {
  metadata: FORM_METADATA,
  scaleTable: SCALE_SCORE_TABLE_25MC4,
  questions: questions_25MC4,
  categoryCounts: CATEGORY_COUNTS_25MC4,
  getScaleScore,
  getQuestionsByCategory,
  getScoredQuestions,
  getFieldTestQuestions
};
